// extracted by extract-css-chunks-webpack-plugin
module.exports = {"resellerSelection":"resellerSelection___3Zj6o"};